export default __webpack_public_path__ + "static/media/3rd-blog.1e1a9d12.jpg";